// extracted by mini-css-extract-plugin
module.exports = {"reservationTitle":"GuestReservations_reservationTitle__nxz_O"};